import { render } from "./StatsEmptyState.vue?vue&type=template&id=11ab668d&scoped=true"
import script from "./StatsEmptyState.vue?vue&type=script&lang=ts"
export * from "./StatsEmptyState.vue?vue&type=script&lang=ts"

import "./StatsEmptyState.vue?vue&type=style&index=0&id=11ab668d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11ab668d"

export default script